import { render, staticRenderFns } from "./CourseStatisticInfo.vue?vue&type=template&id=07ce60b4&"
import script from "./CourseStatisticInfo.vue?vue&type=script&lang=js&"
export * from "./CourseStatisticInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports